export default function (questions) {
  const max_order_number = Math.max(
    ...questions.map(question => {
      return question.order
    })
  )

  // Math.max return 0 if in array is null.
  if (Number.isInteger(max_order_number) && max_order_number !== 0) {
    return max_order_number + 1
  }

  return null
}
